import { render, staticRenderFns } from "./LineworksNotify.vue?vue&type=template&id=2df78d2c"
import script from "./LineworksNotify.vue?vue&type=script&lang=js"
export * from "./LineworksNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports